/**
 * ownersTaskService — the OWNERS space's task collection (`ownersTasks`).
 *
 * Confidential CYV business between the two co-owners: pay, payroll, taxes,
 * worker classification. `/ownersTasks` allows read+write only to isOwner() —
 * deliberately NOT isAdmin(), so a non-owner admin is denied; a rules test
 * asserts exactly that, because it is what proves the gate keys on `owner`
 * rather than on `role`.
 *
 * NO CATEGORIES, same as Personal: `taskCategories` is gated isEmployeeOrAdmin()
 * so an owner CAN write to it, which is precisely the accident worth preventing
 * — a payroll category surfacing in the studio's category list. The four
 * category functions throw here rather than silently no-op.
 */

import { createTaskService } from './taskServiceFactory';

const ownersTaskService = createTaskService({
	tasksCollection: 'ownersTasks',
	space: 'owners',
	// categoriesCollection deliberately omitted — see above.
});

export default ownersTaskService;
